import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		dashboardAberto: null,
		acessoAberto: null,
		cadastroAberto: null,
		precoAberto: null,
		vendaAberto: null,
		logisticaAberto: null,
		estoqueAberto: null,
		metaAberto: null,
		manutencaoAberto: null,
		baseAberto: null,
		importacaoAberto: null
	};

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		const usuarioManutencao = this.props.usuarioCarregado && this.props.usuarioCarregado.id == 152;

		const perfilSertaoOperador = this.props.usuarioCarregado && [30, 31, 32].includes(this.props.usuarioCarregado.id_perfil);

		const perfilSertaoDiretor = this.props.usuarioCarregado && [33].includes(this.props.usuarioCarregado.id_perfil);

		if (this.props.usuarioCarregado) {
			if (!this.props.usuarioCarregado.acesso_usuario && (selecionado == '/usuario' || selecionado == '/usuarioPerfil')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_cadastro && (
				selecionado == '/unidade' || selecionado == '/motorista' || selecionado == '/motoristaDocumento'
				|| selecionado == '/veiculoTipo' || selecionado == '/veiculo' || selecionado == '/veiculoDocumento' || selecionado == '/produto' 
				|| (selecionado == '/distribuidora' && !this.props.usuarioCarregado.acesso_preco_dia)  || selecionado == '/tanque' 
				|| selecionado == '/cliente' || selecionado == '/feedbackMotoristaTipo' || selecionado == '/feedbackMotorista'
				|| selecionado == '/local' || selecionado == '/pedidoPrazo'
			)) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_preco_dia && (selecionado == '/precoDia' || selecionado == '/analiseCurvaPreco' || selecionado == '/adicionalDiario' 
				|| selecionado == '/freteLitro' || selecionado == '/custoPrazo'  || selecionado == '/precoGeral' 
				|| selecionado == '/politicaPreco')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_politica && (selecionado == '/acesso_politica')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_vendas && (selecionado == '/pedido')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_pedido_aprovacao && (selecionado == '/pedidoAprovacao')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_logistica && (selecionado == '/pedidoFinalizado' || selecionado == '/pedidoEntrega' 
				|| selecionado == '/pedidoComprovacao' || selecionado == '/entrada' || selecionado == '/saida' 
				|| selecionado == '/transferencia' || selecionado == '/frete')) {
				if (!this.props.usuarioCarregado.acesso_operacao_abastecida || selecionado != '/saida' || selecionado == '/testeQualidade'
					|| selecionado == '/ocorrenciaLogistica' || selecionado == '/telemetria' || selecionado == '/tempoDirecao' 
					|| selecionado == '/motoristaDiaria') {

					if (!this.props.usuarioCarregado.acesso_pedido_aprovacao && !this.props.usuarioCarregado.acesso_vendas) {
						window.location = '/';
					}
				}
			}

			if (!this.props.usuarioCarregado.acesso_vendas && !this.props.usuarioCarregado.acesso_logistica 
				&& (selecionado == '/pedido' || selecionado == 'pedidoLogistica')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_meta_motorista
				&& (selecionado == '/setor' || selecionado == '/apontamentoGrupo' || selecionado == '/apontamentoTipo' 
				|| selecionado == '/apontamento' || selecionado == '/veiculoTipoConsumo' || selecionado == '/metaMotoristaGrupo'
				|| selecionado == '/metaVendedor' || selecionado == '/metaVendedorResultado' || selecionado == '/metaBaseOperadorTrimestre'
				|| selecionado == '/metaBaseOperadorTrimestreApuracao' || selecionado == '/metaBaseSupervisorTrimestre' 
				|| selecionado == '/metaBaseSupervisorTrimestreApuracao')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_base
				&& (selecionado == '/processoLogistica' || selecionado == '/pedidoBase' || selecionado == '/entradaBase'
				|| selecionado == '/transferenciaCargaBase' || selecionado == '/transferenciaDescargaBase' || selecionado == '/pedidoFinalizadoBase'
				|| selecionado == '/metaBaseOperadorTrimestreApuracaoVisualizacao')) {
				window.location = '/';
			}

			if (!this.props.usuarioCarregado.acesso_importacao
				&& (selecionado == '/analiticaImportacaoMes')) {
				window.location = '/';
			}

		}

		if (this.state.dashboardAberto == null && this.state.acessoAberto == null && this.state.cadastroAberto == null
			&& this.state.precoAberto == null && this.state.vendaAberto == null && this.state.logisticaAberto == null 
			&& this.state.estoqueAberto == null && this.state.metaAberto == null && this.state.manutencaoAberto == null
			&& this.state.baseAberto  == null && this.state.importacaoAberto == null) {

			if (selecionado == '/' || selecionado == '/dashboardEstoqueFisico' || selecionado == '/dashboardPedido' || selecionado == '/dashboardPetroshow' || selecionado == '/metaVendaDashboard' 
				|| selecionado == '/metaVendaDashboardGerencia' || selecionado == '/veiculoDashboard' || selecionado == '/veiculoDashboardKmRodado'
				|| selecionado == '/veiculoDespesa' || selecionado == '/metaLogisticaConfiguracao' || selecionado == '/metaLogisticaApuracao'
				|| selecionado == '/dashboardCusto' || selecionado == '/pedidoAnalise' || selecionado == '/despesaPlaca') {
				this.setState({
					...this.state,
					dashboardAberto: true
				});
			}

			if (selecionado == '/usuarioPerfil' || selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			}
			
			if (selecionado == '/unidade' || selecionado == '/motorista' || selecionado == '/motoristaDocumento' 
				|| selecionado == '/veiculoTipo' || selecionado == '/veiculo' || selecionado == '/veiculoDocumento'
				|| selecionado == '/produto' || selecionado == '/distribuidora' || selecionado == '/tanque' || selecionado == '/cliente'
				|| selecionado == '/feedbackMotoristaTipo' || selecionado == '/feedbackMotorista'
				|| selecionado == '/custoTipo' || selecionado == '/receitaTipo' || selecionado == '/local' || selecionado == '/pedidoPrazo') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}

			if (selecionado == '/precoDia' || selecionado == '/analiseCurvaPreco' || selecionado == '/adicionalDiario' || selecionado == '/freteLitro'
				|| selecionado == '/custoPrazo' || selecionado == '/precoGeral' || selecionado == '/politicaPreco' || selecionado == '/entradaDashboard') {
				this.setState({
					...this.state,
					precoAberto: true
				});
			}
						
			if (selecionado == '/pedido' || selecionado == '/pedidoAprovacao' || selecionado == '/clienteMapa' || selecionado == '/pontoMapa'
				|| selecionado == '/prospeccao' || selecionado == '/clienteCRM' || selecionado == '/clienteCRMHistorico'
				|| selecionado == '/whatsapp' || selecionado == '/limiteCredito') {
				this.setState({
					...this.state,
					vendaAberto: true
				});
			}
	
			if (selecionado == '/pedidoLogistica' || selecionado == '/pedidoFinalizado' || selecionado == '/pedidoEntrega' || selecionado == '/pedidoEstoque'
				|| selecionado == '/pedidoComprovacao' || selecionado == '/entrada' || selecionado == '/saida' || selecionado == '/transferencia' 
				|| selecionado == '/testeQualidade' || selecionado == '/frete'
				|| selecionado == '/ocorrenciaLogistica' || selecionado == '/telemetria' || selecionado == '/tempoDirecao' 
				|| selecionado == '/motoristaDiaria') {
				this.setState({
					...this.state,
					logisticaAberto: true
				});
			}

			if (selecionado == '/relatorioMovimentos' || selecionado == '/estoqueManual' || selecionado == '/estoquePetroshow' 
				|| selecionado == '/estoque' || selecionado == '/fechamentoEstoqueDiario') {
				this.setState({
					...this.state,
					estoqueAberto: true
				});
			}

			if (selecionado == '/analiticaImportacaoMes') {
				this.setState({
					...this.state,
					importacaoAberto: true
				});
			}	

			if (selecionado == '/setor' || selecionado == '/pedidoFinapontamentoGrupoalizado' || selecionado == '/apontamentoTipo' 
				|| selecionado == '/apontamento' || selecionado == '/veiculoTipoConsumo' || selecionado == '/metaMotoristaGrupo'
				|| selecionado == '/metaVenda' || selecionado == '/metaLogisticaConfiguracao' || selecionado == '/metaLogisticaApuracao'
				|| selecionado == '/metaVendaTrimestre' || selecionado == '/metaVendaTrimestreApuracao' || selecionado == '/metaVendaTrimestreApuracaoSemanal'
				|| selecionado == '/metaGerenciaSemestre' || selecionado == '/metaGerenciaSemestreApuracao'
				|| selecionado == '/metaHeitorSemestre' || selecionado == '/metaHeitorSemestreApuracao' 
				|| selecionado == '/metaManutencaoConfiguracao' || selecionado == '/metaManutencaoApuracao' || selecionado == '/metaBaseOperadorTrimestre'
				|| selecionado == '/metaBaseOperadorTrimestreApuracao' || selecionado == '/metaBaseSupervisorTrimestre'
				|| selecionado == '/metaBaseSupervisorTrimestreApuracao') {
				this.setState({
					...this.state,
					metaAberto: true
				});
			}

			if (selecionado == '/oficina' || selecionado == '/manutencao' || selecionado == 'manutencaoArea' 
				|| selecionado == '/manutencaoItem' || selecionado == '/manutencaoPreventivaTipo' 
				|| selecionado == '/manutencaoPreventiva') {
				this.setState({
					...this.state,
					manutencaoAberto: true
				});
			}

			if (selecionado == '/processoLogistica' || selecionado == '/pedidoBase' || selecionado == '/entradaBase'
				|| selecionado == '/transferenciaCargaBase' || selecionado == '/transferenciaDescargaBase' || selecionado == '/equipamentoAlocacao'
				|| selecionado == '/pedidoFinalizadoBase' || selecionado == '/metaBaseOperadorTrimestreApuracaoVisualizacao'
				|| selecionado == '/metaBaseSupervisorTrimestreApuracaoVisualizacao') {
				this.setState({
					...this.state,
					baseAberto: true
				});
			}

		}
		
		
		return (
			<nav className="mt-2">
								    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuTree icon={'fas fa-columns'} label={'Dashboards'}
						display={this.state.dashboardAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: !this.state.dashboardAberto,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >					

						<MenuItem path='/' label='Saldos' icon='far fa-chart-bar' active={selecionado == '/'} />
						{!perfilSertaoDiretor &&
						<MenuItem path='dashboardEstoqueFisico' label='Estoque Físico' icon='fas fa-ruler-combined' active={selecionado == '/dashboardEstoqueFisico'} />}
						{!perfilSertaoDiretor &&
						<MenuItem path='dashboardPedido' label='Dashboard Pedido' icon='fas fa-chart-line' active={selecionado == '/dashboardPedido'} />}
						
						{!perfilSertaoDiretor &&
						<MenuItem path='dashboardPetroshow' label='Infinitum X Petroshow' icon='fas fa-tasks' active={selecionado == '/dashboardPetroshow'} />}

						{(this.props.usuarioCarregado && 
							(
								(this.props.usuarioCarregado.acesso_vendas && !perfilSertaoOperador)
								|| this.props.usuarioCarregado.id == 51 /*TV*/
								|| this.props.usuarioCarregado.acesso_meta_motorista
							)
						) &&
						<MenuItem path='metaVendaDashboard' label='Dashboard Meta de Venda' icon='fas fa-comments-dollar' active={selecionado == '/metaVendaDashboard'} />}

						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.id == 1 || this.props.usuarioCarregado.id == 4 
							|| this.props.usuarioCarregado.id == 74 || this.props.usuarioCarregado.id == 56)) &&
						<MenuItem path='metaVendaDashboardGerencia' label='Dashboard Meta Gerência' icon='fas fa-comment-dollar' active={selecionado == '/metaVendaDashboardGerencia'} />}
						
						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_vendas || this.props.usuarioCarregado.acesso_logistica || this.props.usuarioCarregado.id == 51 /*TV*/)) &&
						<MenuItem path='veiculoDashboard' label='Dashboard Frota' icon='fas fa-shipping-fast' active={selecionado == '/veiculoDashboard'} />}

						{(this.props.usuarioCarregado && ((this.props.usuarioCarregado.acesso_vendas) || (this.props.usuarioCarregado.acesso_logistica) || this.props.usuarioCarregado.id == 51 /*TV*/)) &&
						<MenuItem path='veiculoDashboardKmRodado' label='Eficiência da Frota' icon='fas fa-tachometer-alt' active={selecionado == '/veiculoDashboardKmRodado'} />}
						
						{(this.props.usuarioCarregado && ((this.props.usuarioCarregado.acesso_vendas && !perfilSertaoOperador) || (this.props.usuarioCarregado.acesso_logistica && !perfilSertaoOperador) || this.props.usuarioCarregado.id == 51 /*TV*/)) &&
						<MenuItem path='despesaPlaca' label='Custos da Frota' icon='fas fa-search-dollar' active={selecionado == '/despesaPlaca'} />}

						{/* Janiel, Pedro, Artur Gonçalves Rodrigues */}
						{(this.props.usuarioCarregado && ([1, 4, 74].includes(this.props.usuarioCarregado.id) || perfilSertaoDiretor) && !perfilSertaoOperador) &&
						<MenuItem path='dashboardCusto' label='Custos' icon='fas fa-hand-holding-usd' active={selecionado == '/dashboardCusto'} />}

						{(this.props.usuarioCarregado && 
							(
								this.props.usuarioCarregado.acesso_vendas
							)
						) &&
						<MenuItem path='pedidoAnalise' label='Vendas' icon='fas fa-dollar-sign' active={selecionado == '/pedidoAnalise'} />}
						
					</MenuTree>

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_usuario
					) &&
					<MenuTree icon={'fas fa-user'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: !this.state.acessoAberto,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_usuario ? (
							<MenuItem submenu path='usuarioPerfil' label='Perfil de Usuário' icon='fas fa-user-tag' active={selecionado == '/usuarioPerfil'} />
						) :null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_usuario ? (
							<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-users' active={selecionado == '/usuario'} />
						) : null}
					</MenuTree>}

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_cadastro  
						|| this.props.usuarioCarregado.acesso_preco_dia
					) &&
					<MenuTree icon={'fas fa-th-list'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: !this.state.cadastroAberto,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='unidade' label='Unidade' icon='fas fa-building' active={selecionado == '/unidade'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='motorista' label='Motorista' icon='fas fa-user-plus' active={selecionado == '/motorista'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='motoristaDocumento' label='Motorista - Documentos' icon='fas fa-address-card' active={selecionado == '/motoristaDocumento'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='veiculoTipo' label='Tipo de Veículo' icon='fas fa-truck-loading' active={selecionado == '/veiculoTipo'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='veiculo' label='Veículo' icon='fas fa-truck' active={selecionado == '/veiculo'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='veiculoDocumento' label='Veículo - Documentos' icon='fas fa-id-card' active={selecionado == '/veiculoDocumento'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='produto' label='Produto' icon='fas fa-list' active={selecionado == '/produto'} />
						) : null}
						{this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_cadastro || this.props.usuarioCarregado.acesso_preco_dia) ? (
							<MenuItem submenu path='distribuidora' label='Distribuidora' icon='fas fa-industry' active={selecionado == '/distribuidora'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro  ? (
							<MenuItem submenu path='local' label='Local' icon='fas fa-map-marked' active={selecionado == '/local'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='tanque' label='Tanque' icon='fas fa-gas-pump' active={selecionado == '/tanque'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='cliente' label='Cliente' icon='fas fa-user-edit' active={selecionado == '/cliente'} />
						) : null}

						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='feedbackMotoristaTipo' label='Feedback - Tipo' icon='fas fa-list-alt' active={selecionado == '/feedbackMotoristaTipo'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='feedbackMotorista' label='Feedback - Motorista' icon='fas fa-comments' active={selecionado == '/feedbackMotorista'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='equipamentoAlocacao' label='Alocação de Equipamentos' icon='fas fa-gas-pump' active={selecionado == '/equipamentoAlocacao'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='custoTipo' label='Tipos de Custo' icon='fas fa-funnel-dollar' active={selecionado == '/custoTipo'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='receitaTipo' label='Tipos de Receita' icon='fas fa-search-dollar' active={selecionado == '/receitaTipo'} />
						) : null}
						{this.props.usuarioCarregado && [1, 13, 37, 4, 74, 8, 155].includes(this.props.usuarioCarregado.id) && //Janiel, Fabio, Camila, Gabriella, Pedro, Artur e Gabi
						<MenuItem submenu path='pedidoPrazo' label='Prazos dos Pedidos' icon='fas fa-calendar-alt' active={selecionado == '/pedidoPrazo'} />}
					</MenuTree>}

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_preco_dia  
						|| this.props.usuarioCarregado.acesso_politica
					) &&
					<MenuTree icon={'fas fa-hand-holding-usd'} label={'Precifição'}
						display={this.state.precoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: !this.state.precoAberto,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='precoDia' label='Preço do Dia' icon='fas fa-receipt' active={selecionado == '/precoDia'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='analiseCurvaPreco' label='Análise Curva de Preço' icon='fas fa-stream' active={selecionado == '/analiseCurvaPreco'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='adicionalDiario' label='Adicional Diário' icon='fas fa-money-check' active={selecionado == '/adicionalDiario'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='freteLitro' label='Valor Frete' icon='fas fa-road' active={selecionado == '/freteLitro'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='custoPrazo' label='Custo do Prazo' icon='fas fa-calendar' active={selecionado == '/custoPrazo'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_preco_dia ? (
							<MenuItem submenu path='precoGeral' label='Preço Geral' icon='fas fa-sort-amount-down' active={selecionado == '/precoGeral'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_politica ? (
							<MenuItem submenu path='politicaPreco' label='Política de Preços' icon='fas fa-funnel-dollar' active={selecionado == '/politicaPreco'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_politica ? (
							<MenuItem submenu path='entradaDashboard' label='Últimas Compras' icon='fas fa-money-check' active={selecionado == '/entradaDashboard'} />
						) : null}
					</MenuTree>}

					{(this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_vendas
						|| this.props.usuarioCarregado.acesso_pedido_aprovacao
						|| this.props.usuarioCarregado.acesso_pedido_aprovacao
						|| this.props.usuarioCarregado.acesso_logistica
						|| this.props.usuarioCarregado.acesso_cadastro 
						|| this.props.usuarioCarregado.id_perfil == 16 //Limite de Crédito 
						|| perfilSertaoDiretor
					)) &&
					<MenuTree icon={'fas fa-money-check'} label={'Venda'}
						display={this.state.vendaAberto}
						onClick={() =>
							this.setState({
								...this.state,								
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: !this.state.vendaAberto,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_vendas ? (
							<MenuItem submenu path='pedido' label='Pedidos' icon='fas fa-clipboard-list' active={selecionado == '/pedido'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_pedido_aprovacao ? (
							<MenuItem submenu path='pedidoAprovacao' label='Giro - Aprovar' icon='fas fa-clipboard-check' active={selecionado == '/pedidoAprovacao'} />
						) : null}
						{(this.props.usuarioCarregado && 
								(this.props.usuarioCarregado.acesso_vendas
								|| this.props.usuarioCarregado.acesso_pedido_aprovacao 
								|| this.props.usuarioCarregado.acesso_logistica
								|| perfilSertaoDiretor)) &&
						<MenuItem path='clienteMapa' label='Mapa' icon='fas fa-map' active={selecionado == '/clienteMapa'} />}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 && !perfilSertaoDiretor) /*TV*/ &&
						<MenuItem path='pontoMapa' label='Ponto' icon='fas fa-map-marker-alt' active={selecionado == '/pontoMapa'} />}
						{/* <MenuItem path='veiculoStatus' label='Mapa de Veículos' icon='fas fa-truck' active={selecionado == '/veiculoStatus'} /> */}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 && !perfilSertaoDiretor) /*TV*/ &&
						<MenuItem path='prospeccao' label='Prospecção' icon='fas fa-clipboard-list' active={selecionado == '/prospeccao'} />}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 && !perfilSertaoDiretor) /*TV*/ &&
						<MenuItem path='clienteCRM' label='Cliente - Vendas' icon='fas fa-headphones' active={selecionado == '/clienteCRM'} />}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 && !perfilSertaoDiretor) /*TV*/ &&
						<MenuItem path='clienteCRMHistorico' label='Contatos - Histórico' icon='fas fa-list' active={selecionado == '/clienteCRMHistorico'} />}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 && !perfilSertaoDiretor) /*TV*/ &&
						<MenuItem path='whatsapp' label='WhatsApp Histórico' icon='fab fa-whatsapp' active={selecionado == '/whatsapp'} />}
						{this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_cadastro || this.props.usuarioCarregado.id_perfil == 16 //Limite de Crédito  
							|| (this.props.usuarioCarregado.acesso_vendas)) ? (
						<MenuItem submenu path='limiteCredito' label='Limite de Crédito' icon='fas fa-search-dollar' active={selecionado == '/limiteCredito'} />
						) : null}
					</MenuTree>}

					{this.props.usuarioCarregado && (
						(this.props.usuarioCarregado.acesso_vendas)  
						|| (this.props.usuarioCarregado.acesso_pedido_aprovacao)
						|| this.props.usuarioCarregado.acesso_logistica
						|| this.props.usuarioCarregado.acesso_operacao_abastecida
					) &&
					<MenuTree icon={'fas fa-truck'} label={'Logística'}
						display={this.state.logisticaAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: !this.state.logisticaAberto,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						{this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_vendas || this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem path='pedidoLogistica' label='Giro - Aprovado' icon='fas fa-paste' active={selecionado == '/pedidoLogistica'} />
						) : null}
						{this.props.usuarioCarregado && 
							(this.props.usuarioCarregado.acesso_vendas
							|| this.props.usuarioCarregado.acesso_pedido_aprovacao 
							|| this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='pedidoFinalizado' label='Giro - Finalizado' icon='fas fa-check-double' active={selecionado == '/pedidoFinalizado'} />
						) : null}
						{this.props.usuarioCarregado && 
							((this.props.usuarioCarregado.acesso_vendas)
							|| (this.props.usuarioCarregado.acesso_pedido_aprovacao) 
							|| (this.props.usuarioCarregado.acesso_logistica)) ? (
							<MenuItem submenu path='pedidoEntrega' label='Giro - Entrega' icon='fas fa-shipping-fast' active={selecionado == '/pedidoEntrega'} />
						) : null}
						{this.props.usuarioCarregado && 
							((this.props.usuarioCarregado.acesso_vendas)
							|| (this.props.usuarioCarregado.acesso_pedido_aprovacao) 
							|| (this.props.usuarioCarregado.acesso_logistica)) ? (
							<MenuItem submenu path='pedidoComprovacao' label='Giro - Comprovação' icon='far fa-check-square' active={selecionado == '/pedidoComprovacao'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='pedidoEstoque' label='Giro - Estoque' icon='fas fa-clipboard-list' active={selecionado == '/pedidoEstoque'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='entrada' label='Entrada' icon='fas fa-plus-square' active={selecionado == '/entrada'} />
						) : null}
						{this.props.usuarioCarregado && (
							(this.props.usuarioCarregado.acesso_logistica)|| this.props.usuarioCarregado.acesso_operacao_abastecida
						) ? (
							<MenuItem submenu path='saida' label='Saída' icon='fas fa-check' active={selecionado == '/saida'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='transferencia' label='Transferência' icon='fas fa-random' active={selecionado == '/transferencia'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='frete' label='Frete' icon='fas fa-route' active={selecionado == '/frete'} />
						) : null}
						<MenuItem submenu path='testeQualidade' label='Teste de Qualidade' icon='fas fa-vial' active={selecionado == '/testeQualidade'} />
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='ocorrenciaLogistica' label='Ocorrências - Logística' icon='fas fa-exclamation-triangle' active={selecionado == '/ocorrenciaLogistica'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='telemetria' label='Telemetria' icon='fas fa-road' active={selecionado == '/telemetria'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='tempoDirecao' label='Tempo de Direção' icon='fas fa-user-clock' active={selecionado == '/tempoDirecao'} />
						) : null}
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica) ? (
							<MenuItem submenu path='motoristaDiaria' label='Diária' icon='fas fa-table' active={selecionado == '/motoristaDiaria'} />
						) : null}
					</MenuTree>}

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_logistica
						|| this.props.usuarioCarregado.acesso_operacao_abastecida
						|| this.props.usuarioCarregado.acesso_vendas
					) &&
					<MenuTree icon={'fas fa-glass-whiskey'} label={'Estoque'}
						display={this.state.estoqueAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: !this.state.estoqueAberto,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica ? (
							<MenuItem submenu path='relatorioMovimentos' label='Movimentos' icon='fas fa-receipt' active={selecionado == '/relatorioMovimentos'} />
						) : null}

						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_operacao_abastecida) &&
						<MenuItem path='estoqueManual' label='Manual' icon='fas fa-pencil-ruler' active={selecionado == '/estoqueManual'} />}
					
						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_logistica)) &&
						<MenuItem path='estoquePetroshow' label='Petroshow' icon='fas fa-file-powerpoint' active={selecionado == '/estoquePetroshow'} />}

						{(this.props.usuarioCarregado 
							&& (this.props.usuarioCarregado.acesso_logistica || this.props.usuarioCarregado.acesso_vendas || this.props.usuarioCarregado.ajuste_saldo)) &&
						<MenuItem path='estoque' label='Estoque Base' icon='fas fa-ruler-vertical' active={selecionado == '/estoque'} />}

						{(this.props.usuarioCarregado 
							&& (this.props.usuarioCarregado.acesso_logistica || this.props.usuarioCarregado.acesso_vendas || this.props.usuarioCarregado.ajuste_saldo)) &&
						<MenuItem path='fechamentoEstoqueDiario' label='Estoque Diário' icon='fas fa-calendar-check' active={selecionado == '/fechamentoEstoqueDiario'} />}
					</MenuTree>}

					{/*<MenuTree icon={'fas fa-dot-circle'} label={'Metas - Vendedor'}
						display={this.state.metaVendedorAberto}
						onClick={() =>
							this.setState({
								...this.state,
								metaVendedorAberto: !this.state.metaVendedorAberto,
							})
						} >
						<MenuItem path='metaVendedor' label='Meta' icon='fas fa-users' active={selecionado == '/metaVendedor'} />
						<MenuItem path='metaVendedorResultado' label='Resultado' icon='far fa-chart-bar' active={selecionado == '/metaVendedorResultado'} />
					</MenuTree>*/}
				
					{/*this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 /*TV*/ /*&&
					<MenuItem path='checklist' label='Checklist Configuração' icon='fas fa-tasks' active={selecionado == '/checklist'} />*/}
							
					{((this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_meta_motorista
						|| this.props.usuarioCarregado.acesso_cadastro
						|| [6, 13, 19, 7, 74, 28].includes(this.props.usuarioCarregado.id_perfil)
						|| [1, 4, 56, 74, 59, 63, 129, 74].includes(this.props.usuarioCarregado.id)
					)) && !perfilSertaoOperador) &&
					<MenuTree icon={'fas fa-bullseye'} label={'Metas'}
						display={this.state.metaAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: !this.state.metaAberto,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: false
							})
						} >
						<MenuItem path='setor' label='Setor' icon='fas fa-users' active={selecionado == '/setor'} />
						{/* <MenuItem path='apontamentoGrupo' label='Grupo do Apontamento' icon='fas fa-bars' active={selecionado == '/apontamentoGrupo'} /> */}
						<MenuItem path='apontamentoTipo' label='Tipo do Apontamento' icon='fas fa-list-ol' active={selecionado == '/apontamentoTipo'} />
						{this.props.usuarioCarregado && (
							this.props.usuarioCarregado.acesso_meta_motorista
						) &&
						<MenuItem path='veiculoTipoConsumo' label='Parâmetro de Consumo' icon='fas fa-list' active={selecionado == '/veiculoTipoConsumo'} />}
						<MenuItem path='apontamento' label='Apontamento' icon='fas fa-paste' active={selecionado == '/apontamento'} />
						{/*<MenuItem path='metaMotoristaGrupo' label='Grupo do Motorista' icon='fas fa-th' active={selecionado == '/metaMotoristaGrupo'} />*/}
						{this.props.usuarioCarregado && (
							this.props.usuarioCarregado.acesso_meta_motorista
						) &&
						<MenuItem path='metaMotorista' label='Motorista' icon='fas fa-paste' active={selecionado == '/metaMotorista'} />}
						{/*this.props.usuarioCarregado && this.props.usuarioCarregado.id != 51 &&
						<MenuItem path='metaVenda' label='Meta de Venda' icon='fas fa-tasks' active={selecionado == '/metaVenda'} />*/}

						{(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaLogisticaConfiguracao' label='Logística - Conf' icon='fas fa-cogs' active={selecionado == '/metaLogisticaConfiguracao'} />}

						{(this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro) &&
						<MenuItem path='metaLogisticaApuracao' label='Logística - Apuração' icon='fas fa-shipping-fast' active={selecionado == '/metaLogisticaApuracao'} />}

						{(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaVendaTrimestre' label='Venda - Conf' icon='fas fa-search-dollar' active={selecionado == '/metaVendaTrimestre'} />}

						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_cadastro || [6, 13, 19, 7, 74, 28].includes(this.props.usuarioCarregado.id_perfil))) &&
						<MenuItem path='metaVendaTrimestreApuracao' label='Venda - Apuração' icon='fas fa-money-check-alt' active={selecionado == '/metaVendaTrimestreApuracao'} />}

						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_cadastro || [6, 13, 19, 7, 74, 28].includes(this.props.usuarioCarregado.id_perfil))) &&
						<MenuItem path='metaVendaTrimestreApuracaoSemanal' label='Venda - Semanal' icon='fas fa-calendar-week' active={selecionado == '/metaVendaTrimestreApuracaoSemanal'} />}

						{(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaGerenciaSemestre' label='Gerência - Conf' icon='fas fa-hand-holding-usd' active={selecionado == '/metaGerenciaSemestre'} />}

						{(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaGerenciaSemestreApuracao' label='Gerência - Apuração' icon='fas fa-file-invoice-dollar' active={selecionado == '/metaGerenciaSemestreApuracao'} />}

						{/*(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaHeitorSemestre' label='Meta Heitor - Configuração' icon='fas fa-cog' active={selecionado == '/metaHeitorSemestre'} />*/}

						{/* Infinitum, Pedro, Heitor */}
						{/*(this.props.usuarioCarregado && [1, 4, 56, 78, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaHeitorSemestreApuracao' label='Meta Heitor - Apuração' icon='fas fa-chart-bar' active={selecionado == '/metaHeitorSemestreApuracao'} />*/}

						{(this.props.usuarioCarregado && [1, 4, 56, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaManutencaoConfiguracao' label='Manutenção - Conf' icon='fas fa-wrench' active={selecionado == '/metaManutencaoConfiguracao'} />}
						{/* Infinitum, Pedro, Éder, ANA CLARA DEVIDES DE OLIVEIRA, KESIA MARTA FERREIRA DA SILVA, ARTHUR */}
						{(this.props.usuarioCarregado && [1, 4, 56, 59, 63, 129, 74].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaManutencaoApuracao' label='Manutenção - Apuração' icon='fas fa-poll' active={selecionado == '/metaManutencaoApuracao'} />}

						{/*PEDRO AUGUSTO PEIXOTO RODRIGUES, Artur Gonçalves Rodrigues, Camila Faverao Inheta*/}
						{(this.props.usuarioCarregado && [1, 4, 74, 56].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaBaseOperadorTrimestre' label='Operador de Base - Conf' icon='fas fa-gas-pump' active={selecionado == '/metaBaseOperadorTrimestre'} />}
						{(this.props.usuarioCarregado && [1, 4, 74, 56].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaBaseOperadorTrimestreApuracao' label='Operador Base - Apuração' icon='fas fa-chart-bar' active={selecionado == '/metaBaseOperadorTrimestreApuracao'} />}
						{(this.props.usuarioCarregado && [1, 4, 74, 56].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaBaseSupervisorTrimestre' label='Supervisor Base - Conf' icon='fas fa-user-check' active={selecionado == '/metaBaseSupervisorTrimestre'} />}
						{(this.props.usuarioCarregado && [1, 4, 74, 56].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem path='metaBaseSupervisorTrimestreApuracao' label='Supervisor Base - Apuração' icon='fas fa-chart-area' active={selecionado == '/metaBaseSupervisorTrimestreApuracao'} />}

					</MenuTree>}

					{((this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro) || usuarioManutencao) &&
					<MenuTree icon={'fas fa-wrench'} label={'Manutenção'}
						display={this.state.manutencaoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: !this.state.manutencaoAberto,
								baseAberto: false,
								importacaoAberto: false
							})
						} >

						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='oficina' label='Oficina' icon='fas fa-warehouse' active={selecionado == '/oficina'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='manutencaoArea' label='Item de Manutenção' icon='fas fa-list' active={selecionado == '/manutencaoArea'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='manutencaoItem' label='Reporte de Manutenção' icon='fas fa-clipboard-list' active={selecionado == '/manutencaoItem'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='manutencao' label='Manutenção' icon='fas fa-wrench' active={selecionado == '/manutencao'} />
						) : null}

						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='manutencaoPreventivaTipo' label='Tipo da Preventiva' icon='fas fa-tools' active={selecionado == '/manutencaoPreventivaTipo'} />
						) : null}

						{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cadastro ? (
							<MenuItem submenu path='manutencaoPreventiva' label='Manutenção Preventiva' icon='fas fa-calendar-check' active={selecionado == '/manutencaoPreventiva'} />
						) : null}

					</MenuTree>}

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_base
					) &&
					<MenuTree icon={'fas fa-warehouse'} label={'Base'}
						display={this.state.baseAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: !this.state.baseAberto,
								importacaoAberto: false
							})
						} >
						<MenuItem submenu path='processoLogistica' label='Processos' icon='fas fa-clipboard-list' active={selecionado == '/processoLogistica'} />
						<MenuItem submenu path='pedidoBase' label='Carregamento' icon='fas fa-truck-loading' active={selecionado == '/pedidoBase'} />
						<MenuItem submenu path='entradaBase' label='Descarga' icon='fas fa-truck' active={selecionado == '/entradaBase'} />
						<MenuItem submenu path='transferenciaCargaBase' label='Transferência - Carga' icon='fas fa-level-down-alt' active={selecionado == '/transferenciaCargaBase'} />
						<MenuItem submenu path='transferenciaDescargaBase' label='Transferência - Descarga' icon='fas fa-level-up-alt' active={selecionado == '/transferenciaDescargaBase'} />
						<MenuItem submenu path='equipamentoAlocacao' label='Motobombas' icon='fas fa-gas-pump' active={selecionado == '/equipamentoAlocacao'} />
						{(this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 27) && //Manutenção + Frota + Base
						<MenuItem submenu path='pedidoFinalizadoBase' label='Giro - Finalizado' icon='fas fa-check-double' active={selecionado == '/pedidoFinalizadoBase'} />}
						{(this.props.usuarioCarregado && (this.props.usuarioCarregado.id_perfil == 17 || this.props.usuarioCarregado.id == 1)) && //Base
						<MenuItem submenu path='metaBaseOperadorTrimestreApuracaoVisualizacao' label='Meta do Operador' icon='fas fa-chart-bar' active={selecionado == '/metaBaseOperadorTrimestreApuracaoVisualizacao'} />}
						{/* 79-HENRIQUE SANTOS | 68-VALDOMIR | 69-WALACY */}
						{(this.props.usuarioCarregado && [1, 79, 68, 69].includes(this.props.usuarioCarregado.id)) &&
						<MenuItem submenu path='metaBaseSupervisorTrimestreApuracaoVisualizacao' label='Meta do Supervisor' icon='fas fa-user-check' active={selecionado == '/metaBaseSupervisorTrimestreApuracaoVisualizacao'} />}
					</MenuTree>}

					{/*this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 2 &&
					<MenuItem path='chamado' label='Solicitação de Melhorias' icon='fas fa-hands-helping' active={selecionado == '/chamado'} />*/}

					{this.props.usuarioCarregado && (
						this.props.usuarioCarregado.acesso_importacao
					) &&
					<MenuTree icon={'fas fa-file-upload'} label={'Importação'}
						display={this.state.importacaoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								dashboardAberto: false,
								dashboardAberto: false,
								acessoAberto: false,
								cadastroAberto: false,
								precoAberto: false,
								vendaAberto: false,
								logisticaAberto: false,
								estoqueAberto: false,
								metaAberto: false,
								manutencaoAberto: false,
								baseAberto: false,
								importacaoAberto: !this.state.importacaoAberto
							})
						} >
						<MenuItem submenu path='analiticaImportacaoMes' label='Custos e Receitas' icon='fas fa-file-invoice-dollar' active={selecionado == '/analiticaImportacaoMes'} />
					</MenuTree>}

					<MenuItem path='denuncia' label='Denúncias e Reclamações' icon='fas fa-bullhorn' active={selecionado == '/denuncia'} />

					{(this.props.usuarioCarregado && this.props.usuarioCarregado.bloqueia_base) &&
					<MenuItem path='bloqueioBase' label='Bloqueio da Base' icon='fas fa-lock' active={selecionado == '/bloqueioBase'} />}
					
				</ul>
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
